document.addEventListener('DOMContentLoaded', () => {
    const sliderEls = Array.from(
        document.querySelectorAll('.customers-slide.v2 .customers-slide__slider')
    );

    if (sliderEls.length === 0) return;

    const prefersReducedMotion = window.matchMedia(
        '(prefers-reduced-motion: reduce)'
    ).matches;

    const initMarquee = (sliderEl) => {
        const trackEl = sliderEl.querySelector('.customers-slide__track');
        if (!trackEl || trackEl.children.length === 0) return;

        // Base auto-scroll speed in px/sec (negative = scroll left). Tunable per
        // instance via data-speed / data-friction on the slider element.
        const speedAttr = parseFloat(sliderEl.dataset.speed);
        const frictionAttr = parseFloat(sliderEl.dataset.friction);
        const baseSpeed = prefersReducedMotion
            ? 0
            : -Math.abs(isNaN(speedAttr) ? 40 : speedAttr);
        // How fast velocity eases back toward baseSpeed after a flick (per frame).
        const friction = isNaN(frictionAttr) ? 0.05 : frictionAttr;

        // Clone the original set of items until the track is at least twice the
        // viewport width, so wrapping by one set width is always seamless.
        const originalItems = Array.from(trackEl.children);
        const measureSetWidth = () =>
            originalItems.reduce((sum, el) => sum + el.offsetWidth, 0);

        let setWidth = measureSetWidth();
        if (setWidth === 0) return;

        const targetWidth = sliderEl.offsetWidth * 2 + setWidth;
        let guard = 0;
        while (trackEl.scrollWidth < targetWidth && guard < 50) {
            originalItems.forEach((el) => trackEl.appendChild(el.cloneNode(true)));
            guard++;
        }

        let position = 0;
        let velocity = baseSpeed;
        let dragging = false;
        let didDrag = false;
        let lastPointerX = 0;
        let samples = []; // recent {x, t} for computing the release (flick) velocity
        let lastFrame = null;

        // Wrap position into (-setWidth, 0] so translate stays bounded both ways.
        const wrap = (value) => {
            value %= setWidth;
            if (value > 0) value -= setWidth;
            return value;
        };

        const render = () => {
            trackEl.style.transform = 'translate3d(' + position + 'px, 0, 0)';
        };

        const loop = (now) => {
            if (lastFrame === null) lastFrame = now;
            const dt = Math.min((now - lastFrame) / 1000, 0.05); // seconds, capped
            lastFrame = now;

            if (!dragging) {
                velocity += (baseSpeed - velocity) * friction;
                position = wrap(position + velocity * dt);
                render();
            }

            window.requestAnimationFrame(loop);
        };

        const onPointerDown = (event) => {
            dragging = true;
            didDrag = false;
            lastPointerX = event.clientX;
            samples = [{ x: event.clientX, t: event.timeStamp }];
            sliderEl.classList.add('is-dragging');
            if (sliderEl.setPointerCapture) {
                try {
                    sliderEl.setPointerCapture(event.pointerId);
                } catch (e) {}
            }
        };

        const onPointerMove = (event) => {
            if (!dragging) return;
            const deltaX = event.clientX - lastPointerX;
            lastPointerX = event.clientX;
            if (Math.abs(event.clientX - samples[0].x) > 5) didDrag = true;

            position = wrap(position + deltaX);
            render();

            samples.push({ x: event.clientX, t: event.timeStamp });
            if (samples.length > 5) samples.shift();
        };

        const endDrag = () => {
            if (!dragging) return;
            dragging = false;
            sliderEl.classList.remove('is-dragging');

            // Release velocity from the recent pointer samples (px/sec).
            const first = samples[0];
            const last = samples[samples.length - 1];
            const elapsed = last.t - first.t;
            if (elapsed > 0) {
                velocity = ((last.x - first.x) / elapsed) * 1000;
            }
            samples = [];
        };

        sliderEl.addEventListener('pointerdown', onPointerDown);
        sliderEl.addEventListener('pointermove', onPointerMove);
        sliderEl.addEventListener('pointerup', endDrag);
        sliderEl.addEventListener('pointercancel', endDrag);
        sliderEl.addEventListener('pointerleave', endDrag);

        // Suppress the logo link click when the pointer was actually dragged.
        trackEl.addEventListener(
            'click',
            (event) => {
                if (didDrag) {
                    event.preventDefault();
                    event.stopPropagation();
                }
            },
            true
        );

        // Re-measure on resize so the wrap width stays correct.
        window.addEventListener('resize', () => {
            setWidth = measureSetWidth();
        });

        render();
        window.requestAnimationFrame(loop);
    };

    sliderEls.forEach(initMarquee);
});



// WEBPACK FOOTER //
// ./resources/assets/js/modules/customers-slide-v2.js